import Paper, { type PaperProps } from "@mui/material/Paper";

export function JsonDisplay({
  data,
  paperProps,
}: {
  data: unknown;
  paperProps?: PaperProps;
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        background: (theme) => theme.palette.grey[100],
        overflow: "auto",
      }}
      {...paperProps}
    >
      <code>
        <pre style={{ margin: 0 }}>{JSON.stringify(data, null, 2)}</pre>
      </code>
    </Paper>
  );
}
